export const LayoutFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div>&copy; {currentYear} SIS</div>
  )
}
